import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNextdoorComponent } from './simple-icons-nextdoor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNextdoorComponent ],
    exports:      [ SimpleIconsNextdoorComponent ],
    bootstrap:    []
})
export class SimpleIconsNextdoorModule {}
